export const ADD_SUCCESS = 'Новый банк добавлен';
export const ADD_ERROR = 'Не удалось добавить банк';
